export const COPIED_STATE_RESET_DELAY = 2000;

export const getOrderItemKey = (productId: string, material: string) =>
  `${productId}-${material}`;

export const getShortOrderId = (orderId: string) => orderId.slice(0, 8);
